import { getNgbDateStructFromDayJs } from '@mwe/utils';
import dayjs from 'dayjs';

export const minBirthDate = getNgbDateStructFromDayJs(dayjs().subtract(126, 'year'));
export const maxBirthDate = getNgbDateStructFromDayJs(dayjs().subtract(18, 'year'));

export const minUmmeldedatum = getNgbDateStructFromDayJs(dayjs());
export const maxUmmeldedatum = getNgbDateStructFromDayJs(dayjs().add(30, 'day'));
